import React from 'react';
import css from '~/features/dashboard/components/song-details/styles.module.scss';
import { Typography } from '@material-ui/core';
import { VerticalPopver } from '~/features/dashboard/components/vertical-popover';

const MetaCardInfoRow: React.FC<{ title: string; text: string; stepNo: number; gotoStepSong: (songStep: any) => void }> = ({
    title,
    text,
    stepNo,
    gotoStepSong,
}) => {
    return (
        <div className={css.metaRow}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <Typography variant={'subtitle1'} className={'bold'}>
                        {title}
                    </Typography>
                </div>
                <div>{stepNo !== 7 && <VerticalPopver childClassName={css.editIcon} actionsList={`edit`} onClickEdit={() => gotoStepSong(stepNo)} />}</div>
            </div>
            <Typography variant={'subtitle2'} className={'gray'}>
                {text}
            </Typography>
        </div>
    );
};

export default MetaCardInfoRow;
